import { type ReactNode, useId, useState } from "react";
import { twMerge } from "tailwind-merge";
import { InputLabel } from "./Input";
import { InputContext } from "./InputContext";
import { InputContainer } from "./InputContainer";

export const InputField = ({
  label,
  children,
  className,
  labelClassName,
  containerClassName,
  note,
}: {
  label: ReactNode;
  children: ReactNode;
  className?: string;
  labelClassName?: string;
  containerClassName?: string;
  note?: ReactNode;
}) => {
  const inputId = useId();
  const [icon, setIcon] = useState<string>();

  return (
    <InputContext.Provider
      value={{
        inputId,
        icon,
        setIcon,
      }}
    >
      <div className={twMerge("flex flex-col gap-1", className)}>
        <InputLabel className={labelClassName}>{label}</InputLabel>
        <InputContainer className={containerClassName}>
          {children}
        </InputContainer>
        {note}
      </div>
    </InputContext.Provider>
  );
};
